"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AD_DISCOVERY_TITLE_EXCERPT_LENGTH = void 0;
/**
 * How long the copy excerpt in a saved competitor ad's title runs. Shared so
 * the board picker's preview name and the title the save persists are built
 * by the same rule.
 */
exports.AD_DISCOVERY_TITLE_EXCERPT_LENGTH = 60;
